import axios from 'axios';



const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': "application/json" },
});


export class ReservationFetchAPI {
    // Get reservation codes by product
    static async getReservationcodesbyProduct(group_id, token) {
        const res = await server(`/reservation_codes/${group_id}`, {
            method: "get",
            headers: { 'x-access-token': token }
        });
        return res
    }


    // Update reservation code
    static async putReservation(group_id, data, token) {
        const res = await server(`/reservation_codes/${group_id}`, {
            method: "put",
            headers: { 'x-access-token': token },
            data
        });
        return res
    }

    // Get reservations 
    static async getReservationsClients(branchoffice_id, business_id, minDate, maxDate, token) {
        const res = await server(`/reservations?branchoffice_id=${branchoffice_id}&business_id=${business_id}&minDate=${minDate}&maxDate=${maxDate}`, {
            method: "get",
            headers: { 'x-access-token': token }
        });
        return res
    }

    // Update reservation status
    static async putReservationClient(reservation_id, data, token) {
        const res = await server(`/reservation/${reservation_id}`, {
            method: "put",
            headers: { 'x-access-token': token },
            data
        });
        return res
    }

    //Function to create a new client reservation 
    static async createReservationClient(data, token) {
        const res = await server(`/reservations`, {
            method: "post",
            headers: { 'x-access-token': token },
            data
        });
        return res
    }

    //Function to get reservation client by id
    static async getReservationClientById(reservation_id, token) {
        const res = await server(`/reservation/${reservation_id}`, {
            method: "get",
            headers: { 'x-access-token': token }
        });
        return res
    }
}